module.exports = __webpack_public_path__ + "img/sortImg1-1-6.6063a97c.png";